import Vue from 'vue'
import App from './App.vue'
import router from './router'



// 图片预览插件
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  tapToClose: true,
  fullscreenEl: false
}
Vue.use(preview, options)

// 引入全局工具类
import T from './common/js/tools/index.js'
window.T = T
// 引入jsBridge方法
import './common/js/jsbridge.js'

// import './common/js/remDefind.js'
import './common/styles/index.scss'
import './common/styles/iconFont/iconfont.css'

// 引入本地模拟原生方法
import './nativeTest'


import Cmp from './components/base'
Object.keys(Cmp).forEach((key) => {
  Vue.component(key, Cmp[key])
})

import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  preLoad: 1.3,
  error: './static/bg_default.png',
  loading: './static/bg_default.png'
})

Vue.config.productionTip = false
if (process.env.VUE_APP_RUN_ENV !== "pro") {
  //动态引入eruda
  const eruda = require("eruda")
  eruda.init()
}
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')